{
	"title": "Materiale disponibile",
	"showAllTitle": "Afișează toate materialele",
	"table": {
		"material": "Material",
		"invoicedQuantity": "Cantitate facturată",
		"remainingForTransfer": "Rămas pentru crearea declarației",
		"fetchError": "Nu s-au putut prelua materialele",
		"noMaterials": {
			"title": "Nu există materiale disponibile",
			"description": "În prezent nu aveți materiale disponibile pe {{productName}}. Vă rugăm să contactați reprezentantul de vânzări pentru a adăuga contractul/contractele în contul dumneavoastră."
		}
	}
}
